module.exports = __webpack_public_path__ + "img/bq.86619b3b.png";